module.exports = __webpack_public_path__ + "img/riskleftsection.26c28f36.png";